import { keyBy } from 'lodash'

import { RootState } from 'types'
import { Action } from 'redux/actions'
import { PropertyActions } from 'redux/actions/properties'

export default function reduce(state: RootState['properties'] = {}, action: Action): RootState['properties'] {
  switch (action.type) {
    case PropertyActions.UPSERT_PROPERTY: {
      const { property } = action.payload
      return { ...state, [property.id]: property }
    }

    case PropertyActions.UPSERT_PROPERTIES: {
      const { properties } = action.payload
      return {
        ...state,
        ...keyBy(properties, (p) => p.id),
      }
    }

    case PropertyActions.REMOVE_PROPERTY: {
      const { propertyId } = action.payload
      const { [propertyId]: omit, ...rest } = state
      return rest
    }

    default:
      return state
  }
}
